import React from 'react';
import VoiceComponent from './VoiceComponent';
import VoiceComponent1 from './VoiceComponent1';

import './App.css';


function App(props) {

  return (
    <div id='main'>
      <div className="main-inner">
       
        <h1>
          Unsupervised Speech Decomposition Via Triple Information Bottleneck: 
          <font style={{color:"#58c3c2"}}> Audio Demo</font>
        </h1>
        <p>This demo webpage provides sound examples for <font style={{color:"#58c3c2"}}><b>SpeechSplit</b></font>, an autoencoder that can decompose speech into content, timbre, rhythm and pitch. The following GIF illustrates the working mechanism of SpeechFlow.</p> 
        <p></p>
        <div style={{ margin: '30px auto' }}>
        <img src="spect/flow_plot.gif" alt="animated" width="900px"/>
        </div>

        <p>Below are audio clips of aspect-specific conversion, which corresponds to <font style={{color:"#58c3c2"}}><b>section 5.2</b></font> in the paper. It is an iteractive experience. For each source-target pair, you can:</p>
        <ul>
          <li><font style={{color:"#58c3c2"}}><b>Select the aspect(s) you wish to convert</b></font>, and then the corresponding converted speech will automatically load.</li>
          <li><font style={{color:"#58c3c2"}}><b>Flip the source and target speech</b></font> by toggling the switch.</li>
        </ul>
        <VoiceComponent root="p226_p231_003002" reverse="p231_p226_003002" uttr_id="Utterance 1" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p240_p256_024001" reverse="p256_p240_024001" uttr_id="Utterance 2" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p231_p270_003002" reverse="p270_p231_003002" uttr_id="Utterance 3" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent1 root="p226_p231_024002" reverse="p231_p226_024002" uttr_id="Something Fun" bkg_id="block3" lb_bkg_id="block-label2"/>
        <VoiceComponent root="p245_p258_001" reverse="p258_p245_001" uttr_id="Utterance 4" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p233_p240_003001" reverse="p240_p233_003001" uttr_id="Utterance 5" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p239_p226_006001" reverse="p226_p239_006001" uttr_id="Utterance 6" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p228_p270_024002" reverse="p270_p228_024002" uttr_id="Utterance 7" bkg_id="block2" lb_bkg_id="block-label1"/>
        <VoiceComponent root="p225_p258_001" reverse="p258_p225_001" uttr_id="Utterance 8" bkg_id="block2" lb_bkg_id="block-label1"/>
        
      </div>
      
    </div>
  );
}

export default App;
